import type { Theme } from "@mui/material/styles";

const iconButton = {
  defaultProps: {
    size: "medium" as const,
  },
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.text.secondary,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    }),
  },
};

export default iconButton;
